import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { connect, useSelector, useDispatch } from "react-redux"
import { Link } from "react-router-dom"

import { showRightSidebarAction, toggleLeftmenu } from "../../store/actions"
import { startTimer, stopTimer } from "store/timer/actions"

import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

import logo from "../../assets/images/brands/logo_brand.jfif"

import { withTranslation } from "react-i18next"
import { app_url } from "app_config"
import { axiosbaseurl } from "configure"
import moment from "moment"

const Header = props => {
  const [timerdata, setTimerData] = useState(null)
  const [elapsedTime, setElapsedTime] = useState("00:00:00")
  const [totalHours, setTotalHours] = useState("00:00")
  const [idleHours, setIdleHours] = useState("00:00")
  const [expectedHours, setExpectedHours] = useState("00:00")

  const { timer: timerState, emp_time: emp_timeState } = useSelector(state => state)

  const dispatch = useDispatch()

  useEffect(() => {
    fetchActiveTimer()
  }, [])

  useEffect(() => {
    if (!timerState.timer) {
      setTimerData(null)
    }
  }, [timerState.timer])

  useEffect(() => {
    if (timerState.timer && !timerdata) {
      fetchActiveTimer()
    }
  }, [timerState.timer])

  useEffect(() => {
    if (!timerdata?.createdAt) return

    const startTime = new Date(timerdata.createdAt)

    const updateElapsed = () => {
      const now = new Date()
      const diff = now - startTime

      const hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, "0")
      const minutes = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(
        2,
        "0"
      )
      const seconds = String(Math.floor((diff / 1000) % 60)).padStart(2, "0")

      setElapsedTime(`${hours}:${minutes}:${seconds}`)
    }

    updateElapsed()
    const interval = setInterval(updateElapsed, 1000)

    return () => clearInterval(interval)
  }, [timerdata?.createdAt])

  const fetchActiveTimer = async () => {
    try {
      const response = await axiosbaseurl.get("task-updates/active/timer")

      if (response.data?.success && response.data?.data) {
        setTimerData({ ...response.data.data })
        dispatch(startTimer())
      } else {
        setTimerData(null)
        dispatch(stopTimer())
      }
    } catch (error) {
      console.error("Timer fetch failed:", error)
      setTimerData(null)
      dispatch(stopTimer())
    }
  }

  const getTotalHours = async () => {
    try {
      const response = await axiosbaseurl.get(
        "task-updates/today/working/hours"
      )
      if (response.data.success) {
        setTotalHours(response.data.totalHours)
        setIdleHours(response.data.idleHours)

        setExpectedHours(response.data.expectedHours || "00:00")
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getTotalHours()
  }, [timerState.timer, emp_timeState.emp_time])

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to={app_url} className="logo logo-dark">
                <span>
                  <img src={logo} alt="" height="66" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={() => props.toggleLeftmenu(!props.leftMenu)}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          </div>

          <div>
            {timerdata ? (
              <div className="d-flex align-items-center justify-content-between">
                <Link to={`${app_url}tasks`}>
                  <i
                    className="fa fa-stopwatch fs-4 text-danger me-2 bx-tada"
                    title={`#${timerdata?.task?.id} ${timerdata?.task?.title} timer is running...`}
                  ></i>
                </Link>

                <div
                  className="py-1 px-2 fs-6 fw-bold text-dark"
                  title="Time Elapsed"
                >
                  {elapsedTime}
                </div>

                <div
                  className="py-1 px-2 fs-6 fw-bold text-primary me-1"
                  title="Client Code"
                >
                  {timerdata?.task?.client?.clientCode || "--"}
                </div>

                <div
                  className="py-1 px-2 fs-6 fw-bold text-primary me-1"
                  title="Service Name"
                >
                  {timerdata?.task?.serviceName?.serviceName || "--"}
                </div>
              </div>
            ) : null}
          </div>

          <div
            className="d-flex align-items-center gap-3"
            onMouseEnter={fetchActiveTimer}
          >
            <div className="d-flex flex-column lh-sm justify-content-between align-items-center">
              <div className="fs-5 fw-bolder ">
                {totalHours} <span className="fs-6">hrs</span>
              </div>
              <div className="text-primary fw-semibold my-1" style={{ fontSize: '12px' }}>
                Today's Working Hours{" "}
              </div>
              <div className="text-dark fw-semibold" style={{ fontSize: '10px' }}>
                ( Expected hours {expectedHours} hrs ){" "}
              </div>
            </div>
            <div className="d-flex flex-column justify-content-between align-items-center lh-sm">
              <div className="fs-5 fw-bolder">
                {idleHours} <span className="fs-6">hrs</span>
              </div>
              <div className="text-danger fw-semibold my-1" style={{ fontSize: '12px' }}>
                Today's Idle Hours{" "}
              </div>
              <div className="text-white fw-semibold" style={{ fontSize: '10px' }}>
                {" . "}
              </div>
            </div>
            <NotificationDropdown
              notifications={props.notifications}
              setNotifications={props.setNotifications}
            />

            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout
  return { layoutType, showRightSidebar, leftMenu }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header))
